import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AppsData.css";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import BigLogo from "../../assets/svg/logoiconx2.png";
import cplogo from "../../assets/images/CPLogo.png";
import sportlogo from "../../assets/images/sportLogo.png";
import stocklogo from "../../assets/images/stockLogo.png";
import votingLogo from "../../assets/images/votingLogo.png";
import v2eLogo from "../../assets/images/VTElogo.png";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
// logoiconx2

interface AppsDataProps {
  totalVotes?: number;
  targetVotes?: number;
}

const PText = styled("p")({
  fontSize: window.innerWidth <= 600? "10px" : "16px",
  textAlign:"center",
  color:"white",
});


interface ProgressProps {
  blocks: number;
  total: number;
}

const Progress = ({ blocks, total }: ProgressProps) => {
  const [style, setStyle] = useState({ opacity: 0, width: '0%' });

  const stage = blocks;
  const fillValue = 100 / total;
  const progressValue = Math.floor(stage * fillValue);
  const finalWidth = `${progressValue >= 1 ? progressValue : 1}%`;

  useEffect(() => {
    const timeout = setTimeout(() => {
      setStyle({
        opacity: 1,
        width: finalWidth,
      });
    }, 200);

    return () => clearTimeout(timeout); // Cleanup timeout on unmount or re-render
  }, [blocks, total]); // Only run when these values change

  return (
    <div className="appsprogress"
    style={{height:`${window.screen.width>767?"40px":"30px"}`}}
    >
      <PText className="appsprogress-text"
      style={{
        fontSize:window.screen.width < 370?"10px":""
      }}
      >
        <strong>Stage {stage || 0} of {total} - Double V Back Active!</strong>
      </PText>
      <div className="appsprogress-done" style={style} />
    </div>
  );
};

const AppsData: React.FC<AppsDataProps> = () => {
  const [percentage, setPercentage] = useState(0);
  const [totalVoteCount, setTotalVoteCount] = useState(0);
  const [liveTotalVote, setLiveTotalVote] = useState<any>({});
  const [paxDistributionData, setPaxDistributionData] = useState<any>({});
  const location = useLocation();
  const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  // const [textColor, setTextColor] = useState('white');
  const title = searchParams.get("title");
  const logo = searchParams.get("logo");  
  const textColor = searchParams.get('textColor');
  const TotalVoteNo = Number(searchParams.get('TotalVoteNo') || 0);  
  const stateLimit: Record<number, number> = {
    1:1000,
    2:1500,
    3:2000,
    4:2500,
    5:3000,
    6:3500,
    7:4000,
    8:4500,
    9:5000,
    10:5500,
    11:6000,
    12:6500,
    13:7000,
    14:7500,
    15:10000,
  }   

  useEffect(() => {
    const fetchPaxDistributionData = async () => {
      try {
        const response = await axios.post(
          "https://us-central1-votetoearn-9d9dd.cloudfunctions.net/getCurrentPaxDistribution",
          { data: {} }
        );
        setPaxDistributionData(response.data.result);
      } catch (error) {
        console.error("Error fetching pax distribution data:", error);
      }
    };
  
    fetchPaxDistributionData();
  }, []);
 const leftBlock = (stateLimit[Number(paxDistributionData?.currentVSatge)] ?? 0) - (paxDistributionData?.total100 ?? 0)


  return (
    <div      
      // className="container"
      style={{
        display: "flex",
        width: "100% !important",
        // height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        cursor: pathname == "/progress-bar" ? "pointer" : "",
        backgroundColor: "transparent",
        // marginTop:"50px"        
      }}
    >
      {Object.keys(paxDistributionData).length == 0?
      <span
      className="loading"
      style={{
        color: "white",
        wordBreak: "break-all",
        paddingTop: "3px",
        paddingLeft: "10px",        
        fontSize: "1.6em",
      }}
    >
      Loading...
    </span>
      :
        <div className="progress-bar-container" style={{ width: "100%" }}>                
        {/* <PText className="fw-bold text-uppercase" style={{ fontSize:window.screen.width>767 ?"25px":"18px" }}>{paxDistributionData?.totalVstage} STAGES V BACK PLAN</PText>         */}
        <PText className="" style={{ fontSize:window.screen.width>767 ?"25px":"18px" }}>Buy now get 100% Vcoin back</PText>        
        <PText style={{ fontSize:window.screen.width>767 ?"20px":"14px" }}>Next stage <span className="fw-bold" style={{ fontSize:window.screen.width>767 ?"20px":"14px" }}>get 95%</span></PText>        
        <div
          style={{
            width: "100% !important",
            padding: "0px",
            maxWidth: "600px",
            margin: "0px auto",
          }}
        >
          <Progress blocks={paxDistributionData?.currentVSatge} total={paxDistributionData?.totalVstage}/>          
          {/* <Progress done={percentage>0?percentage:BarPercent.toFixed(2) } />           */}
        </div>   
        <div className="d-flex justify-content-center flex-wrap">          
          <PText><strong>Buy with <span className="textGolden">$1</span> - Get <span className="textGolden">{paxDistributionData?.vCoinPrice || 0}</span> Vcoin</strong> |</PText> 
          <PText>&nbsp;Next stage: <strong>Buy with <span className="textGolden">$1</span> - Get <span className="textGolden">{paxDistributionData?.nextStageVcoinPrice || 0}</span> Vcoin</strong></PText>                  
          </div>               
          <PText>Stage blocks left: <strong>{paxDistributionData?.currentVSatge >14 ?0:leftBlock.toLocaleString('en-IN') || 0}</strong>  | Vcoins earned: <strong className="textGolden">{paxDistributionData?.vCoinDistributed?.toLocaleString('en-IN') || 0}</strong></PText>        
      </div>}
    </div>
  );
};

export default AppsData;
